module.exports = __webpack_public_path__ + "static/transparent_name.345ac4aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/transparent_name.png
// module id = ./src/images/transparent_name.png
// module chunks = 114276838955818